export default __webpack_public_path__ + "static/media/icon_22.9ec8a0ae.png";